import { MasterOption } from "../types/masters";

function createMasterOptionMap(options: MasterOption[]) {
  return Object.fromEntries(options.map(each => [each.value, { ...each }]));
}

export default createMasterOptionMap;
